import { mobile } from '@/utils/IE';
import UniversalReport from '@tencent/universal-report';

const PageId = {
  get: () => document.body.getAttribute('dt-pgid'),
  set: (id) => {
    document.body.setAttribute('dt-pgid', id);
  },
};
const Lang = { 'zh-CN': 0, 'en-US': 1 };
// 上报渠道来源
const Channel = { search: 1, wechat: 2, email: 3 };
// 上报搜索来源只判断这4家搜索平台标识
const Search = 'baidu|google|so|sogou';
// 上报页面的路由别名（避免干扰业务路由跳转，这里做上报别名映射）
const RouterReflect = {};

const myConsole = (obj) => {
  console.warn('report params == > ', obj);
};

class SetReport {
  constructor() {
    this.InitReport();
  }

  Send(type, params = '') {
    if (type && this[type]) {
      this[type](params);
    } else {
      throw new Error(`'${type}' method is not exist in report Class`);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  pageIn(params) {
    if (params) {
      // PageId.set(`page_${(RouterReflect[params] || params).toLowerCase()}`);
      this.sendReport
        .setPage(
          {
            pgid: `${(RouterReflect[params] || params).toLowerCase()}`,
          },
          document.body,
        )
        .observe(`${(RouterReflect[params] || params).toLowerCase()}`);
    }
  }

  pageOut(params) {
    if (params) {
      const name = params.toLowerCase();
      this.sendReport.reportPgOut(`${RouterReflect[name] || name}`, true);
      // this.sendReport.reportPgOut(`${(RouterReflect[params] || params).toLowerCase()}`, true);
    }
  }

  reportEvent(params = {}) {
    myConsole(params);
    // * dt_imp     元素曝光
    // * dt_clck    元素点击
    // * dt_imp_end 元素结束曝光
    this.sendReport.reportEvent({
      pgid: PageId.get(),
      eventName: params.eventName || 'dt_clck',
      businessParams: {
        eid: params.eid,
        ...{ ...params.extParams },
      },
    });
  }

  // 重置用户公共参数
  ResetUserPublic() {
    this.SetPublic({
      user_id: '',
      user_type: '',
      applicant_type: '',
    });
  }

  // 公共参数设定
  SetPublic(params) {
    if (this.sendReport) {
      this.sendReport.setPublicParams(params);
    } else {
      this.InitReport(params);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getSource() {
    const Params = window.location.hash.match(/source=(\w+)/i);
    if (Params === null) {
      const { referrer } = document;
      if (referrer) {
        const Host = referrer.match(/http(s)?:\/\/(.*?)\//i);
        if (Host[0].match(new RegExp(Search, 'i'))) {
          return Channel.search;
        }
      }
      return 0;
    }
    return Channel[Params[1]] || 0;
  }

  getBrowserName() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('edge')) return 'Edge';
    if (userAgent.includes('chrome') && !userAgent.includes('edge')) return 'Chrome';
    if (userAgent.includes('firefox')) return 'Firefox';
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) return 'Safari';
    if (userAgent.includes('trident')) return 'IE';
    return 'unknown';
  }

  getOS() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('windows')) return 'Windows';
    if (userAgent.includes('macintosh')) return 'macOS';
    if (userAgent.includes('linux')) return 'Linux';
    if (userAgent.includes('android')) return 'Android';
    if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'iOS';
    return 'unknown';
  }

  getDeviceBrand() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'Apple';
    if (userAgent.includes('samsung')) return 'Samsung';
    if (userAgent.includes('huawei')) return 'Huawei';
    if (userAgent.includes('xiaomi')) return 'Xiaomi';
    if (userAgent.includes('honor')) return 'Honor';
    if (userAgent.includes('oppo')) return 'Oppo';
    if (userAgent.includes('vivo')) return 'Vivo';
    return 'unknown';
  }

  // 初始化大同上报，接受设定公共参数
  InitReport(params = {}) {
    // 大同业务数据上报
    try {
      this.sendReport = new UniversalReport({
        beacon: '0WEB01PPJB5MX8RM',
        // 初始公共参数
        publicParams: {
          platform: mobile ? 'h5' : 'web',
          is_test: process.env.VUE_APP_REPORT === 'production' ? 0 : 1,
          is_env: process.env.VUE_APP_REPORT,
          // language: 'zh-CN',
          user_language: Lang[localStorage.getItem('lang') || 'zh-CN'],
          source_user: this.getSource(),
          browser: this.getBrowserName(),
          user_os: this.getOS(),
          device_brand: this.getDeviceBrand(),
          ...params,
        },
      });
    } catch (err) {
      this.sendReport = {
        reportPgOut: () => {},
        reportEvent: () => {},
        setPublicParams: () => {},
      };
    }
  }
}

const setReport = new SetReport();

export { setReport };
